import { GetServerSideProps } from "next";
import AgencyDirectory from ".";
import { siteUrl } from "@utils/constant";
import { toTitleCase } from "@utils/common";

type Props = {
    selectedCountry: string;
    selectedCity: string;
};

const AgencySlugPage: React.FC<Props> = ({ selectedCountry, selectedCity }) => {
    const baseCanonical = `${siteUrl}/agencies/`;
    const isCityLevel = !!selectedCity;
    const location = isCityLevel ? selectedCity : selectedCountry;

    const title = `Best WhatsApp Marketing Agencies in ${location} 2025 | Gallabox`;
    const description = `Find the top-rated WhatsApp marketing agencies in ${location}. Compare services, pricing, and reviews to find the best partner for your business.`;

    const canonical = `${baseCanonical}${selectedCountry.toLowerCase()}${selectedCity ? `/${selectedCity.toLowerCase()}` : ""}`;

    return <AgencyDirectory selectedCountry={selectedCountry} selectedCity={selectedCity} title={title} description={description} canonical={canonical} />;
};

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
    const slug = (params?.slug as string[]) || [];

    const rawCountry = slug[0] || "";
    const rawCity = slug[1] || "";

    const selectedCountry = toTitleCase(rawCountry);
    const selectedCity = toTitleCase(rawCity);

    return {
        props: {
            selectedCountry,
            selectedCity,
        },
    };
};

export default AgencySlugPage;
